export const HOME_LATEST_UPDATES_STORAGE_KEY = "trw-home-latest-updates-v1";
export const HOME_LATEST_UPDATES_UPDATED_EVENT = "trw-home-latest-updates-updated";

const DEFAULT_POSTS = [
  {
    title: "Girls Getaways 2026",
    subLine1: "Discover 9 Stunning Trips for Parties",
    subLine2: "Relaxation & Adventures",
    alt: "Discover 9 Stunning Trips for Parties, Relaxation & Adventures",
    image: "/assets/images/home/rethink-ways-latest-updates-1.avif",
    tag: "Friends",
    tagLink: "https://travel.rethinkways.com/category/friends/",
    link: "https://travel.rethinkways.com/girls-trip-destinations-from-india/",
    date: "23/May/2026",
  },
  {
    title: "Offbeat Cruises 2026",
    subLine1: "Discover 10 Incredible Routes",
    subLine2: "Across Unforgettable Trip",
    alt: "Discover 10 Incredible Routes Across Unforgettable Journeys",
    image: "/assets/images/home/rethink-ways-latest-updates-4.avif",
    tag: "Cruise",
    tagLink: "https://travel.rethinkways.com/category/cruise/",
    link: "https://travel.rethinkways.com/offbeat-cruises-incredible-routes/",
    date: "26/May/2026",
    titleWeight: 100,
    subWeight: 700,
    titleFont: "'Yeseva One', Georgia, serif",
    subFont: "Poppins, sans-serif",
    titleColor: "#ffffff",
    swapColors: true,
  },
  {
    title: "Mauritius Attractions 2026",
    subLine1: "25 Beautiful Places for ",
    subLine2: "An Unforgettable Trip",
    alt: "An Unforgettable Island Journey",
    image: "/assets/images/home/rethink-ways-latest-updates-5.avif",
    tag: "Attractions",
    tagLink: "https://travel.rethinkways.com/category/attractions/",
    link: "https://travel.rethinkways.com/mauritius-attractions/",
    date: "24/May/2026",
    titleWeight: 100,
    subWeight: 700,
    titleFont: "Poppins, sans-serif",
    subFont: "'Yeseva One', Georgia, serif",
    titleColor: "#ffffff",
    swapColors: true,
  },
  {
    title: "Bhutan Entry Guide 2026",
    subLine1: "Permits, Entry Rules & ",
    subLine2: "Travel Guidelines for Indians",
    alt: "Bhutan Entry Guide 2026",
    image: "/assets/images/home/rethink-ways-latest-updates-3.avif",
    tag: "VISA Free",
    tagLink: "https://travel.rethinkways.com/category/visa-free/",
    link: "https://travel.rethinkways.com/bhutan-tourist-entry-rules-for-indians-2026/",
    date: "19/May/2026",
    titleWeight: 100,
    subWeight: 700,
    titleFont: "'Yeseva One', Georgia, serif",
    subFont: "Poppins, sans-serif",
    titleColor: "#ffffff",
    swapColors: true,
  },
  {
    title: "Romantic Beach Escapes 2026",
    sub: "Discover 10 Dream Honeymoon Destinations Across the World",
    alt: "Discover 10 Dream Honeymoon Destinations Across the World",
    image: "/assets/images/home/rethink-ways-latest-updates-2.avif",
    tag: "Honeymoon India",
    tagLink: "https://travel.rethinkways.com/category/honeymoon-india/",
    link: "https://travel.rethinkways.com/romantic-beach-honeymoon-destinations/",
    date: "28/May/2026",
  },
];

function safeParse(json, fallback) {
  try {
    const value = JSON.parse(json);
    return value ?? fallback;
  } catch {
    return fallback;
  }
}

export function getDefaultLatestUpdates() {
  return DEFAULT_POSTS.map((item, index) => ({ id: item.id || `default-${index + 1}`, ...item }));
}

export function getStoredLatestUpdates() {
  if (typeof window === "undefined") return [];
  const raw = window.localStorage.getItem(HOME_LATEST_UPDATES_STORAGE_KEY);
  const parsed = safeParse(raw, []);
  return Array.isArray(parsed) ? parsed : [];
}

export function getLatestUpdates({ includeStoredOverrides = true } = {}) {
  const base = getDefaultLatestUpdates();
  if (!includeStoredOverrides) return base;
  const stored = getStoredLatestUpdates();
  return stored.length ? stored : base;
}

export function setLatestUpdates(nextPosts) {
  if (typeof window === "undefined") return;
  const normalized = Array.isArray(nextPosts) ? nextPosts : [];
  window.localStorage.setItem(HOME_LATEST_UPDATES_STORAGE_KEY, JSON.stringify(normalized));
  window.dispatchEvent(new Event(HOME_LATEST_UPDATES_UPDATED_EVENT));
}
